import { useEffect, useState } from "react";

/** Subscribe to a media query. SSR-safe (defaults false until mounted). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

/** Desktop spread reader at >=1024 (single square page + flip below is the
 *  mobile scroll reader for MVP; 768–1023 single-page-flip is a refinement). */
export const DESKTOP_QUERY = "(min-width: 1024px)";

export function usePrefersReducedMotion(): boolean {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
